/* eslint-disable no-underscore-dangle */

import { initialize } from 'redux-form';
import { FORM_NAME } from '../Form';
import { getProps } from '../props';


export default () => async (dispatch, getState) => {

  const { invoice } = getProps();


  const { user } = invoice;
  const contact = invoice.client_contact;

  // Get default CC email from user settings for invoices
  const state = getState();
  const userSettings = (state.core && state.core.userSettings) || {};
  const defaultCcEmail = userSettings.email_default_cc_invoice;

  // Parse comma-separated emails into array
  const defaultCcEmails = defaultCcEmail
    ? defaultCcEmail.split(',').map(e => e.trim()).filter(e => e.length > 0)
    : [];

  //TODO - company name needs to go in here against the subject line
  const values = {
    to: [],
    cc: defaultCcEmails,
    bcc: [],
    subject: `Invoice ${invoice.id}`,
    body: '',
    id: invoice.id,
  };

  if (contact.email) values.to.push(contact.email);

  values.body += `Dear ${contact.first_name}\r\n\r\n`;
  values.body += `Please find attached our invoice.\r\n\r\n`;
  values.body += `Kind Regards\r\n\r\n`;
  values.body += `${user.first_name} ${user.last_name}`


  dispatch(initialize(FORM_NAME, values));

}
